var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgLighthouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fillRule: "nonzero",
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#003C71",
    strokeLinecap: "square",
    strokeWidth: 2,
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 50c0 4.4 3.6 8 8 8 3 0 5.6-1.7 7-4.2 1.4 2.5 4 4.2 7 4.2s5.6-1.7 7-4.2c1.4 2.5 4 4.2 7 4.2s5.6-1.7 7-4.2c1.4 2.5 4 4.2 7 4.2 4.4 0 8-3.6 8-8M9 18l-7-1.6M9 30l-7 1.6M8 24H0M49 18l7-1.6M49 30l7 1.6M50 24h8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 25,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 38h28M15 12h28M49 48l-6-10V12L29 0 15 12v26L9 48"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighthouse);
export default __webpack_public_path__ + "static/media/lighthouse.994c724fcc8ae1d55bd0f20cd1c039a6.svg";
export { ForwardRef as ReactComponent };